import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from "../../component/heroSection/Hero";
import AboutUs from "../../page/AboutUs/AboutUs";
import Services from '../../page/servicesPage/Services';
import Skill from "../../page/skill/Skill";
import Portfolio from '../portfolio/Portfolio';
import Contact from '../contact/Contact';

function Home() {
  const location = useLocation();

  useEffect(() => {
    const state = location.state;
    if (!state || !state.scrollTo) return;

    const { scrollTo } = state;

    if (scrollTo === 'home') {
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(0);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }

    const element = document.getElementById(scrollTo);
    if (!element) return;

    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(element);
    } else {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  return (
    <div>
      <Hero />
      <AboutUs />
      <Services />
      <Skill />
      <Portfolio />
      <Contact />
    </div>
  );
}

export default Home;
